export const CALENDAR_GRID_WEEK_TIME_DROP_AREA_PREFIX = 'calendar-grid-time-'

export const CALENDAR_GRID_WEEK_GROUP_MORE_KEY_SUFFIX = '-more'

export const CALENDAR_GRID_WEEK_LANE_LIMIT = 2

export const CALENDAR_GRID_WEEK_LANE_COUNT_WITH_MORE =
  CALENDAR_GRID_WEEK_LANE_LIMIT + 1

export const CALENDAR_GRID_WEEK_NO_FREE_LANE = -1
